import React from 'react';

interface MonitorSummaryProps {
  isConnected: boolean;
  totalPositions: number;
  totalPL: number;
  lastUpdate: string | null;
}

const MonitorSummary: React.FC<MonitorSummaryProps> = ({ isConnected, totalPositions, totalPL, lastUpdate }) => {
  const formatTime = (ts: string) => {
    const d = new Date(ts);
    return d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
  };

  return (
    <div className="monitor-summary">
      <div className="summary-left">
        <span className={`status-badge ${isConnected ? 'status-live' : 'status-connecting'}`}>
          {isConnected ? 'LIVE' : 'CONNECTING...'}
        </span>
        <span className="summary-positions">{totalPositions} position{totalPositions !== 1 ? 's' : ''}</span>
      </div>
      <div className="summary-right">
        <span className={`summary-pl ${totalPL >= 0 ? 'pl-positive' : 'pl-negative'}`}>
          Total: ${totalPL.toFixed(2)}
        </span>
        {lastUpdate && (
          <span className="summary-time">Updated: {formatTime(lastUpdate)}</span>
        )}
      </div>
    </div>
  );
};

export default MonitorSummary;
